<template>
    <div class="form-box">
        <div class="form-right from7-r">
            <div style="width:100%;height:6vh;padding-left:1vw;background:#fff;display:flex;align-items: center;border-bottom: 3px solid #ecf0f5;">
                项目关键节点计划
            </div>
            <div style="width:100%;height:calc( 100% - 6vh );position: relative;padding:1vh;background:#fff;overflow: auto;">
                <el-table
                    :data="tableData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="projectNodeId"
                    height="97%"
                    :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                    default-expand-all
                    :tree-props="{children: 'childList', hasChildren: 'hasChildren'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发起角色">
                      <template slot-scope="scope">
                          <p>{{scope.row.userName}}</p>
                      </template>
                    </el-table-column>
                    <el-table-column prop="index" label="节点">
                        <template slot-scope="scope">
                            <p>{{scope.row.nodeName}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="进度">
                        <template slot-scope="scope">
                            <!-- <span>{{scope.row.completeRate}} %</span> -->
                            <el-progress :text-inside="true" :stroke-width="20" color="#4D6EB1" :percentage="parseFloat(scope.row.completeRate)"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="时间">
                        <template slot-scope="scope">
                            <p>{{scope.row.completeTime}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.completeRate<100" style="color:#409EFF;">进行中</p>
                            <p v-else style="color:#67C23A">已完成</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="操作">
                        <template slot-scope="scope">
                            <p style="width:100%;" v-if="scope.row.completeRate<100" @click="addNodeProcess(scope.row)">
                                <span class="button" v-if="!scope.row.childList || scope.row.childList.length==0" type="primary">提报</span>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            title="提报"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
                :model="node"
                ref="node"
                label-width="150px"
                :label-position="labelPosition"
            >
                <el-form-item label="进度：">
                   <el-input-number v-model="node.completeRate" :precision="2" :min="curMin" :max="100" label=""></el-input-number> %
                </el-form-item>
                <el-form-item label="计划开始时间：">
                   <el-date-picker
                        v-model="node.startTime"
                        disabled
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="node.completeRate==100" label="实际完成时间：">
                   <el-date-picker
                        v-model="node.actualCompleteTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-else label="本次提报时间：">
                   <el-date-picker
                        v-model="node.writeTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="描述：" v-if="node.completeRate==100">
                    <el-input type="textarea" :rows="5" placeholder="请输入描述" v-model="node.describes"></el-input>
                </el-form-item>
                <el-form-item label="添加照片：" v-if="node.completeRate==100">
                    <el-upload
                        class="avatar-uploader"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data="{type:239}"
                        :show-file-list="false"
                        :on-success="handleIconSuccess"
                    >
                        <img v-if="node.picture" :src="baseCtx+ node.picture" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow()" style="background: #4D6EB1">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import base from '../../../../untils/base'
import myHttp from '../../../../untils/port'
import util from '../../../../untils/util'
import file from '../../../ent/file.vue'
export default {
  components: { file },
    data(){
        return{
            groupId:'',
            dataText: '数据加载中...',
            tableData:[],
            // curId:0,
            addVis:false,
            labelPosition:'right',
            activeNames:[],
            curMin:0,
            node:{
                projectNodeId:'',
                completeRate:'',
                describes:'',
                picture:'',
                writeTime:'',
                actualStartTime:'',
                actualCompleteTime:''
            },
            baseCtx:base.httpCtx,
            uploadUrl: myHttp.uploadPhotosAndThumbnail, //上传地址
            uploadHead: {
                accessToken: util.session.get('token')
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.getLeftMenu()
        this.getData()
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            this.tableData = []
            myHttp.findPlanProjectNode({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        // list[i].childList = list[i].childList?list[i].childList:[]
                        list[i].projectNodeId = list[i].projectNodeId?list[i].projectNodeId:'test0'+i
                    }

                    that.tableData = util.common.listToTree('sysNodeId','parentNodeId',list)
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //展示弹出框
        addNodeProcess(row){
            if(row.childList && row.childList.length>0)return;
            this.addVis = true
            this.node.projectNodeId = row.projectNodeId
            this.node.completeRate = row.completeRate
            this.node.describes = row.completeRate==100?row.describes:''
            this.node.picture = row.completeRate==100?row.picture:''
            this.node.writeTime = row.completeRate==100?row.writeTime:''
            this.node.actualStartTime = row.completeRate==100?row.actualStartTime:''
            this.node.actualCompleteTime = ''
            this.node.startTime = row.startTime
            this.node.sysNodeId = row.sysNodeId
            this.curMin = parseFloat(row.completeRate)
        },

        //上传返回
        handleIconSuccess(res,file){
            if(res.code=='200'){
                this.icon = URL.createObjectURL(file.raw)
                this.node.picture = res.data.savePhotoUrls
                // this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
            }
        },
        //添加
        sumbitAddRow(){
            var that = this
            if(this.node.completeRate==100){
                this.node.writeTime = this.node.actualCompleteTime
            }
            myHttp.nodeSubmitReport(this.node).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('添加成功')
                    that.addVis = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
.button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  font-size: 14px;
  color: #8EA3CE;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.form-box{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    padding: 1vh;
}
.form-right{
    width: 100%;
    height: 100%;
    position: relative;
    
}

.father-item:hover,.child-item:hover{
    background: #E7F1FB;
    cursor: pointer;
}
</style>

<style>
    @import '../../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #dddddd;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(3),.from7-r .el-table--border td:nth-child(3){
        border-right: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(5),.from7-r .el-table--border td:nth-child(5){
        border-right: 1px solid #dddddd;
    }
    .form-right .el-progress-bar__outer{
        background-color: #E0E0E0;
    }
    .form-right .el-progress-bar__innerText{
        font-size: 1vw;
    }
</style>